<template>
<div class="pb-24 pt-2 text-lg">
  <div class="font-bold text-xl my-4 nav-menu-wrapper">
    <a href="javascript: void(0)" @click="$router.push('/tariffs')">
      {{$t('message.tariff.allPage')}}
    </a>
  </div>
  <div class="font-bold text-xl">{{$t('message.tariff.free')}}:</div>
  <div :key="option" v-for="option in upData[nextPlanCode]">
    <vs-icon icon="add" />
    {{$t(`message.tariff.option${option}.header`)}}
  </div>
  <div class="flex justify-between items-stretch my-8 max-w-xl flex-col md:flex-row">
    <vs-card class="mx-4 w-9/12">
      <div slot="header">
        <h5>{{$t('message.tariff.freeOptionPayHeader')}}</h5>
      </div>
      <div class="text-right text-xl mr-4 h-8 mt-4">
        {{$t('message.tariff.freeOptionPayCount', {used: curPayments, max: maxPayments})}}
      </div>
    </vs-card>
    <vs-card class="mx-4 w-9/12">
      <div slot="header">
        <h5>{{$t('message.tariff.minBalanceHeader')}}</h5>
      </div>
      <div class="text-right text-xl mr-4 h-8 mt-4">
        {{$t('message.tariff.minBalanceNow', {amount: minBalance})}}
      </div>
      <div slot="footer" class="text-right text-sm mr-4 mb-4">
        {{$t('message.tariff.minBalanceRecomend', {amount: recommendMinBalance})}}
      </div>
    </vs-card>
    <div class="mx-4 justify-between flex flex-col w-9/12">
      <vs-card>
        <div class="mt-4 mb-0">
          <span class="text-left w-1/2 inline-block">{{$t('message.tariff.interestOnBalance')}}</span>
          <span class="text-right w-1/2 inline-block">{{interestOnBalance}}</span>
        </div>
      </vs-card>
      <vs-card>
        <div class="mt-4 mb-0">
          <span class="text-left w-1/2 inline-block">{{$t('message.tariff.overnightOnBalance')}}</span>
          <span class="text-right w-1/2 inline-block">{{overnightOnBalance}}</span>
        </div>
      </vs-card>
    </div>
  </div>
  <div :key="data['id']" v-for="data in downData.main[curPlanCode]" class="flex justify-between items-stretch my-8 max-w-xl flex-col md:flex-row">
    <vs-card class="mx-4 w-9/12 lg:w-full">
      <div slot="header">
        <h5>{{ $t(`message.tariff.option${data['id']}.header`) }}</h5>
      </div>
      <div class="text-right text-xl mr-4 h-8 mt-4">
        <span v-if="notEmpty(data['val'])">
        {{ data['val'] }}
      </span>
      <span v-if="data['trans']">
        {{ $t(`message.tariff.option${data['id']}.value.${data['trans']}`) }}
      </span>
      </div>
    </vs-card>
  </div>
  <!-- <div :key="data['id']" v-for="data in downData.main[curPlanCode]">
    <vs-icon icon="done" />
    {{$t(`message.tariff.option${data['id']}.header`)}}
    <span v-if="notEmpty(data['val'])">:
      {{data['val']}}
    </span>
    <span v-if="data['trans']">:
      {{$t(`message.tariff.option${data['id']}.value.${data['trans']}`)}}
    </span>
  </div> -->
  <div class="mb-12" />
  <div :key="data['id']" v-for="data in downData.star[curPlanCode]">
    {{$t(`message.tariff.option${data['id']}.star`)}}
    <span v-if="notEmpty(data['val'])">:
      {{data['val']}}
    </span>
    <span v-if="data['trans']">:
      {{$t(`message.tariff.option${data['id']}.starValue.${data['trans']}`)}}
    </span>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import { isNil } from 'lodash'
import TariffUpdate from '@/views/pages/TariffUpdate'
import downData from '@/mixins/downData'

export default {
  name: 'TariffCurrent',
  components: {TariffUpdate},
  mixins: [downData],
  data: () => ({
    showUp: false
  }),
  methods: {
    notEmpty (val) {
      return !isNil(val)
    }
  },
  computed: {
    ...mapGetters('utils', ['getTariffSpec', 'getTariffInfo', 'getTariffs', 'getUpData', 'getTemplate']),
    curPayments () {
      return parseInt(this.getTariffInfo['rtjs_limit_balance'], 10)
    },
    maxPayments () {
      return this.getTariffSpec(this.getTariffInfo['tarif_code'])['rtjs_limit']
    },
    minBalance () {
      return parseFloat(this.getTariffInfo['balance_min']).toFixed(2)
    },
    recommendMinBalance () {
      return parseFloat(this.getTariffSpec(this.getTariffInfo['tarif_code'])['balance_min']).toFixed(2)
    },
    interestOnBalance () {
      return parseFloat(this.getTariffSpec(this.getTariffInfo['tarif_code'])['balance_min_persent']).toFixed(2)
    },
    overnightOnBalance () {
      return parseFloat(this.getTariffSpec(this.getTariffInfo['tarif_code'])['overnight']).toFixed(2)
    },
    currentPlanCode () {
      return this.getTariffInfo['tarif_code']
    },
    nextPlanCode () {
      return this.nextTariffInfo['tarif_code']
    },
    curPlanCode () {
      return this.getTariffInfo['tarif_code']
    },
    nextTariffInfo () {
      const newTraiff = this.getTariffInfo['tariff_recommended']
      const tariffsInfo = Object.values(this.getTariffs).filter(function (item) {
        return item['tarif_code'] === newTraiff
      })

      return tariffsInfo[0]
    }
  }
}
</script>

<style scoped>

</style>
